// 业务页面路由配置
import { lazy } from "react";
import { IRoute } from "@src/Model/IRoute";
import { PCProductRoutes } from "./ProductRoutes";
import { PCIndustryRoutes } from "./IndustryRoutes";

const PCRoutes: IRoute[] = [
    {
        path: "/:lang/home",
        Component: lazy(() => import("@src/Pages/CN/PC/Home")),
    },
    {
        path: "/:lang/download-center/:app?",
        Component: lazy(() => import("@src/Pages/CN/PC/DownloadCenter")),
    },
    {
        path: "/:lang/company-introduce",
        Component: lazy(() => import("@src/Pages/CN/PC/CompanyIntroduce")),
    },
    {
        path: "/:lang/article-center",
        Component: lazy(() => import("@src/Pages/CN/PC/ArticleCenter")),
    },
    {
        path: "/:lang/article-center/detail/:id?",
        Component: lazy(() => import("@src/Pages/CN/PC/ArticleCenter/Detail")),
    },
    {
        path: "/:lang/cases",
        Component: lazy(() => import("@src/Pages/CN/PC/Cases")),
    },
    {
        path: "/:lang/cases/detail/:id?",
        Component: lazy(() => import("@src/Pages/CN/PC/Cases/Detail")),
    },
    ...PCProductRoutes,
    ...PCIndustryRoutes
];

export const PCNoFrameworkRoutes = [
    {
        path: "/:lang/protocol",
        Component: lazy(() => import("@src/Pages/CN/PC/ProtocolAndPrivacy/Protocol")),
    },
    {
        path: "/:lang/privacy",
        Component: lazy(() => import("@src/Pages/CN/PC/ProtocolAndPrivacy/Privacy")),
    }
]

export default PCRoutes;
